import { BaseApiService } from '@shared/services/BaseApiService';
import { WorksheetActionModelSelector } from '@pbx/helpers/worksheets/action-types';
import { isID } from '@shared/helpers/uid';

class WorksheetActionServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(worksheet_id, params) {
    return this.http
      .post(`/${worksheet_id}/actions`, params)
      .then(item => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }

  getItem(worksheet_id, id) {
    return this.http
      .get(`/${worksheet_id}/actions/${id}`)
      .then(item => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }
  
  updateItem(worksheet_id, id, params) {
    return this.http
      .put(`/${worksheet_id}/actions/${id}`, params)
      .then(item => WorksheetActionModelSelector.getBackendModel(item).toFrontend());
  }

  removeItem(worksheet_id, id) {
    return this.http.delete(`/${worksheet_id}/actions/${id}`);
  }

  createOrUpdateItem(worksheet_id, id, params) {
    if (isID(id)) {
      return this.updateItem(worksheet_id, id, params);
    } else {
      return this.createItem(worksheet_id, params);
    }
  }
}

export const WorksheetActionService = new WorksheetActionServiceClass({
  api_version: 2,
  resource: 'pbx/worksheets'
});
